module.exports = __webpack_public_path__ + "static/media/iconEvaluationActive.e9b33b63.svg";